import { getCookie, csrfSafeMethod } from "./libs";

$.ajaxSetup({
    beforeSend: function (xhr, settings) {
        const csrftoken = getCookie('csrftoken');
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
            xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
    }
})


$(() => {
    const $langForm  = $('form#set-language');

    const $langSelect = $langForm.find('[name="language"]')

    const $selectLang = $('#select-lang');

    $selectLang.on('change', (e) => {
        $langSelect.val(e.target.value)
        $langForm.submit()
    })
})